import { HealfManagementTeamRole, NavItem, Role, UserRole } from "../types";

// RBAC should most often be handled on server-side

export class RoleHelper {
  static isWhitelisted = (userRole: UserRole): boolean => {
    return (
      userRole === "VENDOR" ||
      userRole === "HEALF_OPERATIONS" ||
      userRole === "HEALF_OPERATIONS_MANAGER" ||
      userRole === "HEALF_ASSOCIATE_MANAGER" ||
      userRole === "WAREHOUSE" ||
      userRole === "RELABELLING" ||
      userRole === "HEALF_ASSOCIATE" ||
      userRole === "HEALF_ACCOUNTANT" ||
      userRole === "ADMIN"
    );
  };

  static isHealfTeam = (userRole: UserRole): boolean => {
    return userRole.includes("HEALF") || userRole === "ADMIN";
  };

  static isHealfOperationsTeam = (userRole: UserRole): boolean => {
    return userRole === "HEALF_OPERATIONS" || userRole === "HEALF_OPERATIONS_MANAGER" || userRole === "ADMIN";
  };

  static isHealfManagementTeam = (userRole: UserRole): boolean => {
    return userRole === "HEALF_ASSOCIATE_MANAGER" || userRole === "HEALF_OPERATIONS_MANAGER" || userRole === "ADMIN";
  };

  static isHealfAssociateTeam = (userRole: UserRole): boolean => {
    return userRole === "HEALF_ASSOCIATE_MANAGER" || userRole === "HEALF_ASSOCIATE" || userRole === "ADMIN";
  };

  static isWarehouse = (userRole: UserRole): boolean => {
    return userRole === "WAREHOUSE" || userRole === "ADMIN";
  };

  static isRequiredRole = (userRole: UserRole, roleRequired: Role[] | Role): boolean => {
    if (!roleRequired || roleRequired.length === 0 || roleRequired.includes("NONE") || userRole === "ADMIN") {
      return true;
    }

    if (roleRequired.includes("HEALF_MANAGEMENT_TEAM") && RoleHelper.isHealfManagementTeam(userRole)) {
      return true;
    }

    if (roleRequired.includes("HEALF_OPERATIONS_TEAM") && RoleHelper.isHealfOperationsTeam(userRole)) {
      return true;
    }

    if (roleRequired.includes("WHITELISTED") && RoleHelper.isWhitelisted(userRole)) {
      return true;
    }

    if (roleRequired.includes("HEALF_TEAM") && RoleHelper.isHealfTeam(userRole)) {
      return true;
    }

    if (Array.isArray(roleRequired) && roleRequired.includes(userRole)) {
      return true;
    }

    if (roleRequired === userRole) {
      return true;
    }

    return false;
  };

  static readonly roleAssignmentOptions: { [key in HealfManagementTeamRole]: UserRole[] } = {
    HEALF_OPERATIONS_MANAGER: [
      "HEALF_ASSOCIATE",
      "HEALF_OPERATIONS",
      "HEALF_ACCOUNTANT",
      "WAREHOUSE",
      "VENDOR",
      "RELABELLING",
      "HEALF_ASSOCIATE_MANAGER"
    ],
    ADMIN: [
      "HEALF_ASSOCIATE",
      "HEALF_OPERATIONS",
      "HEALF_ACCOUNTANT",
      "WAREHOUSE",
      "VENDOR",
      "RELABELLING",
      "HEALF_ASSOCIATE_MANAGER",
      "HEALF_OPERATIONS_MANAGER",
      "ADMIN"
    ],
    HEALF_ASSOCIATE_MANAGER: ["HEALF_ASSOCIATE"]
  };
}

export const filterNavItemsByRole = (navItems: NavItem[], role: UserRole): NavItem[] =>
  navItems
    .map((item) => {
      if ("children" in item) {
        const children = filterNavItemsByRole(item.children ?? [], role);
        const hasAccess = RoleHelper.isRequiredRole(role, item.roleRequired ?? []);
        return hasAccess || children.length ? { ...item, children } : null;
      }
      const hasAccess = RoleHelper.isRequiredRole(role, item.roleRequired ?? []);
      return hasAccess ? item : null;
    })
    .filter(Boolean) as NavItem[];
